<template>
    <b-modal :id="idModal" class="modal-atv" hide-header hide-footer centered>
        <ActiveCode :previewBook="true" @activeSuccess="handleActiveBookSucess" :isLibraryPage="true" class="margin-center" />
    </b-modal>
</template>

<script>
    import { mapActions } from 'vuex';
    import { STORE_KEY, ID_MODAL_ACTIVE_BOOK } from './../../_store/constants'

    export default {
        name: "modalActiveEbooks",
        components: {
            ActiveCode: () => import('@/modules/ebooks/_components/common/ActiveCode.vue') 
        },
        data() {
            return {
                idModal: ID_MODAL_ACTIVE_BOOK
            }
        },
        methods: {
            ...mapActions(STORE_KEY, ['setBookIdActiveSuccess']),

            handleActiveBookSucess(id) {
                this.setBookIdActiveSuccess(id);
                this.$bvModal.hide(ID_MODAL_ACTIVE_BOOK)
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>